import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button, Badge, Tooltip, OverlayTrigger, Dropdown } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DatePicker from "react-multi-date-picker";
import Edit from './../../../modal/Subscriber_Management/EditSubscriber';
import csv_ico from '../../../../images/export_icons/csv.ico';
import excel_ico from '../../../../images/export_icons/excel.ico';
import print_ico from '../../../../images/export_icons/print.ico';
import new_subs from '../../../../images/new_subs.gif';
import Drop from './../../../modal/Subscriber_Management/ProductDrop';
import Followup from './../../../modal/Subscriber_Management/Followup';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import swal from "sweetalert2";
import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import LoadingComponent from '../../../layouts/nav/loading';
const baseURL = process.env.REACT_APP_API_BASE_URL;

const getStartOfWeek = (date) => {
    const day = date.getDay(), // get the current day of the week
        diff = date.getDate() - day; // calculate the difference in days to the previous Sunday
    const startOfWeek = new Date(date.setDate(diff));
    startOfWeek.setHours(0, 0, 0, 0); // set to midnight
    return startOfWeek;
};

const getEndOfWeek = (date) => {
    const day = date.getDay(),
        diff = date.getDate() + (6 - day); // calculate the difference to the next Saturday
    const endOfWeek = new Date(date.setDate(diff));
    endOfWeek.setHours(23, 59, 59, 999); // set to the end of the day
    return endOfWeek;
};

const Subscribers = () => {

    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const defaultPermissions = {
        view_dashboard: 0,
        branch_man: 0,
        man_branch: 0,
        branch_list: 0,
        branch_add: 0,
        branch_edit: 0,
        branch_view: 0,
        branch_delete: 0,
        branch_add_staff: 0,
        branch_add_area: 0,
        branch_add_dpoint: 0,
        branch_asign_manager: 0,
       
        subscri_man: 0,
        subscriber_list: 0,
        subscriber_view: 0,
        subscriber_edit: 0,
        subscriber_filter: 0,
        subscriber_new_subscription: 0,
        subscriber_convert: 0,
        subs_man: 0,
        subscription_list: 0,
        subscription_view: 0,
        subscription_edit: 0,
        subscription_export: 0,
        subscription_hold: 0,
        subscription_complaints: 0,
        subscription_renewal: 0,
        
    };

    // Immediately load from localStorage if available
    const initialPermissions = (() => {
        const stored = localStorage.getItem('user_permissions');
        return stored ? JSON.parse(stored) : defaultPermissions;
    })();

    const [permissions, setPermissions] = useState(initialPermissions);

    useEffect(() => {
        console.log(permissions);
    }, [permissions]);

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [isVisible, setIsVisible] = useState({});
    const [loading, setLoading] = useState(false);

    // const fetchData = (filter = {}) => {
    //     axios.get(`${baseURL}/subscriber`, { params: filter })
    //         .then(response => {
    //             const fetchedData = response.data.data;
    //             setData(fetchedData);
    //             const visibilityMap = {};
    //             fetchedData.forEach(item => {
    //                 visibilityMap[item.lead_id] = false;
    //             });
    //             setIsVisible(visibilityMap);
    //             setHasFetched(true);
    //         })
    //         .catch(error => {
    //             console.log('There was an error fetching the data!', error);
    //             setHasFetched(true);
    //         });
    // };

    // // fetch data & leadstatus
    // useEffect(() => {
    //     fetchData();
    // }, []);

    const fetchData = useCallback((filter = { branch_id: branch_id }) => {
        setLoading(true);
        axios.get(`${baseURL}/subscriber/new`, { params: filter })
            .then(response => {
                const fetchedData = response.data.data;
                setData(fetchedData);

                const visibilityMap = {};
                fetchedData.forEach(item => {
                    visibilityMap[item.lead_id] = false;
                });

                setIsVisible(visibilityMap);
                setHasFetched(true);
                setLoading(false);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
                setHasFetched(true);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);


    const tableRef = useRef(null);

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);

    const [selectedId, setSelecctedID] = useState("");
    const handleModalToggle_Edit = (selectedId) => {
        setSelecctedID(selectedId);
        setModalType("Edit");
        setOpen(true);
    };

    const handleModalToggle_Drop = (selectedId) => {
        setSelecctedID(selectedId);
        setModalType("Drop");
        setOpen(true);
    };
    const [selected_data, setSelected_data] = useState({});
    const handleModalToggle_Followup = (selectedId, data) => {
        setSelecctedID(selectedId);
        setSelected_data(data);
        setModalType("Followup");
        setOpen(true);
    };

    // -------------------------------------------------------------- Filter Details ---------------------------
    const [filterOpen, setFilterOpen] = useState(false);

    //area
    const [areaOption, setAreaOption] = useState([]);
    const [area, setArea] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/area`, { params: { branch_id } });
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.area_name,
                }));
                const allOption = { value: null, label: "All" };
                setAreaOption([allOption, ...formattedsource]);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    // delivery point
    const [dppoption, setdpoption] = useState([]);
    const [dp, setDp] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/deliverypoint`, { params: { branch_id } });
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.delivery_point,
                }));
                const allOption = { value: null, label: "All" };
                setdpoption([allOption, ...formattedsource]);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);


    // subs option & on select
    const [filter_subs_id, setFilterSubsID] = useState(null);
    const [subsribersOpt, setSubscribersOpt] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/leadsubscription/subscribers`, { params: { branch_id } })
            .then(response => {
                const formatted = response.data.data.map(item => ({
                    value: item.lead,
                    label: item.lead_name,
                }));
                const allOption = { value: null, label: "All" };
                setSubscribersOpt([allOption, ...formatted]);
            })
            .catch(error => {
                console.error('There was an error fetching the data!', error);
            });
    }, []);

    const [filtermob_no, setFilterMob] = useState('');
    const [filteremail_id, setFilterEmail] = useState('');
    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [today_fil_value, setTodayFilValue] = useState(new Date());
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(getStartOfWeek(new Date()));
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(getEndOfWeek(new Date()));
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());

    // --------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------- export -----------------------------------//

    const exportCSV = () => {
        const columnNames = [
            'S.No', 'Lead Name', 'Mobile No', 'Email ID',
            'Lead Address', 'Product', 'Timeline', 'Start Date', 'End Date', 'Area', 'Delivery Point',
            'Total Delivery', 'Delivered', 'Balance Delivery'
        ];

        let serial = 1;

        const formattedData = datas.flatMap((lead) =>
            lead.products.map((product) => ({
                'S.No': serial++,
                'Lead Name': lead.lead_name || '-',
                'Mobile No': lead.lead_mobile || '-',
                'Email ID': lead.lead_email || '-',
                'Lead Address': product.address || lead.lead_address || '-',
                'Product': product.product_name || '-',
                'Timeline': product.duration_name + ' (' + product.duration_days + ' Days)' || '-',
                'Start Date': product.start_date || '-',
                'End Date': product.end_date || '-',
                'Area': product.area || '-',
                'Delivery Point': product.delivery_point || '-',
                'Total Delivery': product.total_delivery || 0,
                'Delivered': product.delivered || 0,
                'Balance Delivery': product.balance || 0,
            }))
        );
        const csv = Papa.unparse({
            fields: columnNames,
            data: formattedData
        });
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'subscrption.csv';
        link.click();
    };

    const exportExcel = () => {
        let serial = 1;

        const formattedData = datas.flatMap((lead) =>
            lead.products.map((product) => ({
                'S.No': serial++,
                'Lead Name': lead.lead_name || '-',
                'Mobile No': lead.lead_mobile || '-',
                'Email ID': lead.lead_email || '-',
                'Lead Address': product.address || lead.lead_address || '-',
                'Product': product.product_name || '-',
                'Timeline': product.duration_name + ' (' + product.duration_days + ' Days)' || '-',
                'Start Date': product.start_date || '-',
                'End Date': product.end_date || '-',
                'Area': product.area || '-',
                'Delivery Point': product.delivery_point || '-',
                'Total Delivery': product.total_delivery || 0,
                'Delivered': product.delivered || 0,
                'Balance Delivery': product.balance || 0,
            }))
        );

        // Create worksheet from formatted data
        const ws = XLSX.utils.json_to_sheet(formattedData);

        // Create a new workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        // Write the workbook to an Excel file and trigger the download
        XLSX.writeFile(wb, 'subscription.xlsx');
    };

    const print = () => {
        // Define the column names for printing
        const columnNames = [
            'S.No', 'Lead Name', 'Mobile No', 'Email ID',
            'Lead Address', 'Product', 'Timeline', 'Start Date', 'End Date', 'Area', 'Delivery Point',
            'Total Delivery', 'Delivered', 'Balance Delivery'
        ];

        let serial = 1;

        const formattedData = datas.flatMap((lead) =>
            lead.products.map((product) => ({
                'S.No': serial++,
                'Lead Name': lead.lead_name || '-',
                'Mobile No': lead.lead_mobile || '-',
                'Email ID': lead.lead_email || '-',
                'Lead Address': product.address || lead.lead_address || '-',
                'Product': product.product_name || '-',
                'Timeline': product.duration_name + ' (' + product.duration_days + ' Days)' || '-',
                'Start Date': product.start_date || '-',
                'End Date': product.end_date || '-',
                'Area': product.area || '-',
                'Delivery Point': product.delivery_point || '-',
                'Total Delivery': product.total_delivery || 0,
                'Delivered': product.delivered || 0,
                'Balance Delivery': product.balance || 0,
            }))
        );

        // Create an HTML table for printing
        let printContent = `<table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
            <thead>
                <tr style="background-color: #f2f2f2;">`;

        // Add column headers
        columnNames.forEach(col => {
            printContent += `<th style="padding: 8px; text-align: left; border: 1px solid #ddd;">${col}</th>`;
        });

        printContent += `</tr></thead><tbody>`;

        // Add the rows of data
        formattedData.forEach(row => {
            printContent += `<tr>`;
            columnNames.forEach(col => {
                printContent += `<td style="padding: 8px; border: 1px solid #ddd;">${row[col]}</td>`;
            });
            printContent += `</tr>`;
        });

        printContent += `</tbody></table>`;

        // Open the print dialog
        const printWindow = window.open('', '', 'height=800,width=1000');
        printWindow.document.write('<html><head><title>Subscription Details</title>');
        printWindow.document.write('<style>table { width: 100%; border-collapse: collapse; }</style>');
        printWindow.document.write('</head><body>');
        printWindow.document.write(printContent);
        printWindow.document.write('</body></html>');
        printWindow.document.close(); // Necessary for IE >= 10
        printWindow.print();
    };

    const onClose = () => {
        setFilterOpen(false);
    };

    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custom Date" }
    ];

    const toggleDiv = (leadId) => {
        setIsVisible(prev => ({
            ...prev,
            [leadId]: !prev[leadId]
        }));
    };

    useEffect(() => {
        if (datas.length === 0 && hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        //   "aaSorting": [],
                        pageLength: 25,
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched, datas.length]);


    const checkdate = (date) => {
        const isToday = new Date(date).toDateString() === new Date().toDateString();
        return isToday;
    }

    const handleStatusToggle = async (id, currentStatus, name) => {

        if (currentStatus === 0) {
            swal.fire({
                html: `
                    <div class="alert alert-danger px-2 py-2" role="alert">
                        <strong>Are you Sure! </strong> You're about to In-active all your Subscription
                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                    <p class="text-center"><b>${name}</b></p>
                    <div class="text-center">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                            <defs>
                                <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#5987dd"/>
                                    <stop offset=".118" stop-color="#638bd6"/>
                                    <stop offset=".316" stop-color="#7d98c3"/>
                                    <stop offset=".572" stop-color="#a8aba3"/>
                                    <stop offset=".871" stop-color="#e3c678"/>
                                    <stop offset="1" stop-color="#ffd364"/>
                                </radialGradient>
                                <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                            </defs>
                            <g id="_27-feel_bad" data-name="27-feel bad">
                                <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                                <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                                <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                                <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                                <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                                <circle class="cls-6" cx="34" cy="22" r="1"/>
                                <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                                <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                                <circle class="cls-6" cx="16" cy="22" r="1"/>
                                <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                                <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                                <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                                <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                                <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                                <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                                <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                                <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                                <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                                <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                                <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                            </g>
                        </svg>
                    </div>
                `,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
                reverseButtons: true,
                customClass: {
                    title: 'fs-6',
                    cancelButton: 'btn btn-sm btn-secondary',
                    confirmButton: 'btn btn-sm btn-danger',
                    htmlContainer: 'text-left'
                },
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const newStatus = currentStatus === 0 ? 1 : 0;
                    axios.put(`${baseURL}/subscriber/status/${id}`, { status: newStatus })
                        .then(response => {
                            toast.success("Status Updated Successfully!");
                            fetchData();
                        })
                        .catch(error => {
                            console.log(error);
                            toast.error("Status Updation Failed");
                            fetchData();
                        });
                } else {
                    fetchData();
                }
            });
        } else if (currentStatus === 1) {
            swal.fire({
                html: `
                    <div class="alert alert-success px-2 py-2" role="alert">
                        <strong>Are you Sure! </strong> You're about to Activate all your In-active Subscription
                        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                    <p class="text-center"><b>${name}</b></p>
                    <div class="text-center">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" id="stars"  width="48" height="48">
                                <defs>
                                    <linearGradient id="b" x1="256" x2="256" y1="487.916" y2="40.466" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#ffe2a9" stop-opacity=".5"></stop>
                                    <stop offset=".289" stop-color="#ffe09e" stop-opacity=".5"></stop>
                                    <stop offset=".653" stop-color="#ffd97f" stop-opacity=".5"></stop>
                                    <stop offset="1" stop-color="#ffcf54" stop-opacity=".5"></stop>
                                    </linearGradient>
                                    <linearGradient id="d" x1="256" x2="256" y1="486.916" y2="41.466" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#de932c"></stop>
                                    <stop offset=".088" stop-color="#e6a236"></stop>
                                    <stop offset=".242" stop-color="#f1b643"></stop>
                                    <stop offset=".417" stop-color="#f9c44d"></stop>
                                    <stop offset=".632" stop-color="#fecd52"></stop>
                                    <stop offset="1" stop-color="#ffcf54"></stop>
                                    </linearGradient>
                                    <linearGradient id="e" x1="256" x2="256" y1="434.797" y2="256.367" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#464144"></stop>
                                    <stop offset=".33" stop-color="#383436"></stop>
                                    <stop offset=".709" stop-color="#231f20"></stop>
                                    </linearGradient>
                                    <linearGradient id="f" x1="89.916" x2="422.084" y1="345.582" y2="345.582" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#ffdd90" stop-opacity=".5"></stop>
                                    <stop offset="1" stop-color="#ffd263" stop-opacity=".5"></stop>
                                    </linearGradient>
                                    <linearGradient id="h" x1="6379.772" x2="6379.772" y1="307.443" y2="226.442" gradientTransform="rotate(180 3317.886 273.55)" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#d1d0d0"></stop>
                                    <stop offset=".334" stop-color="#f2f2f2"></stop>
                                    <stop offset=".518" stop-color="#fff"></stop>
                                    </linearGradient>
                                    <linearGradient id="i" x1="254.5" x2="254.5" y1="460.759" y2="392.506" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#ad3446"></stop>
                                    <stop offset=".214" stop-color="#d43b50"></stop>
                                    <stop offset=".397" stop-color="#ef3f57"></stop>
                                    <stop offset=".505" stop-color="#f94159"></stop>
                                    <stop offset=".641" stop-color="#ed3f56"></stop>
                                    <stop offset=".886" stop-color="#ce394e"></stop>
                                    <stop offset="1" stop-color="#bd364a"></stop>
                                    </linearGradient>
                                    <linearGradient id="j" x1="78.325" x2="221.198" y1="240.676" y2="97.804" gradientTransform="rotate(-5.635 162.482 147.133)" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#2182e2"></stop>
                                    <stop offset="0" stop-color="#3d76cf"></stop>
                                    <stop offset=".001" stop-color="#5c68ba"></stop>
                                    <stop offset=".001" stop-color="#785da7"></stop>
                                    <stop offset=".001" stop-color="#8e5398"></stop>
                                    <stop offset=".002" stop-color="#9f4c8d"></stop>
                                    <stop offset=".003" stop-color="#aa4785"></stop>
                                    <stop offset=".003" stop-color="#b14480"></stop>
                                    <stop offset=".006" stop-color="#b3437f"></stop>
                                    <stop offset="1" stop-color="#5b3671"></stop>
                                    </linearGradient>
                                    <linearGradient id="a" x1="87.161" x2="204.281" y1="240.507" y2="88.615" gradientTransform="rotate(-5.635 162.482 147.133)" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#c49be8"></stop>
                                    <stop offset=".083" stop-color="#bb8ce5"></stop>
                                    <stop offset=".344" stop-color="#a261db"></stop>
                                    <stop offset=".579" stop-color="#8f42d4"></stop>
                                    <stop offset=".778" stop-color="#842fd0"></stop>
                                    <stop offset=".916" stop-color="#8028ce"></stop>
                                    </linearGradient>
                                    <linearGradient id="k" x1="77.731" x2="220.604" y1="240.618" y2="97.745" gradientTransform="scale(-1 1)rotate(-5.635 -93.66 5351.83)" gradientUnits="userSpaceOnUse">
                                    <stop offset="0" stop-color="#2182e2"></stop>
                                    <stop offset="0" stop-color="#3d76cf"></stop>
                                    <stop offset=".001" stop-color="#5c68ba"></stop>
                                    <stop offset=".001" stop-color="#785da7"></stop>
                                    <stop offset=".001" stop-color="#8e5398"></stop>
                                    <stop offset=".002" stop-color="#9f4c8d"></stop>
                                    <stop offset=".003" stop-color="#aa4785"></stop>
                                    <stop offset=".003" stop-color="#b14480"></stop>
                                    <stop offset=".006" stop-color="#b3437f"></stop>
                                    <stop offset="1" stop-color="#5c3773"></stop>
                                    </linearGradient>
                                    <linearGradient xlink:href="#a" id="l" x1="79.998" x2="219.368" y1="233.597" y2="94.228" gradientTransform="scale(-1 1)rotate(-5.635 -93.66 5351.83)"></linearGradient>
                                    <clipPath id="c">
                                    <path fill="none" stroke="url(#b)" stroke-miterlimit="10" stroke-width="2" d="M478.725 264.191c0 123.008-99.717 222.725-222.725 222.725S33.275 387.2 33.275 264.191 132.992 41.466 256 41.466s222.725 99.718 222.725 222.725Z"></path>
                                    </clipPath>
                                    <clipPath id="g">
                                    <path fill="none" d="M420.084 286.553c0 84.639-79.107 148.244-164.084 148.244S91.916 371.192 91.916 286.553c0-20.998 110.515-30.186 164.084-30.186 53.62 0 164.084 9.188 164.084 30.186Z"></path>
                                    </clipPath>
                                </defs>
                                <g clip-path="url(#c)">
                                    <path fill="url(#d)" d="M478.725 264.191c0 123.008-99.717 222.725-222.725 222.725S33.275 387.2 33.275 264.191 132.992 41.466 256 41.466s222.725 99.718 222.725 222.725Z"></path>
                                </g>
                                <path fill="none" stroke="url(#b)" stroke-miterlimit="10" stroke-width="2" d="M478.725 264.191c0 123.008-99.717 222.725-222.725 222.725S33.275 387.2 33.275 264.191 132.992 41.466 256 41.466s222.725 99.718 222.725 222.725Z"></path>
                                <path fill="url(#e)" d="M420.084 286.553c0 84.639-79.107 148.244-164.084 148.244S91.916 371.192 91.916 286.553c0-20.998 110.515-30.186 164.084-30.186 53.62 0 164.084 9.188 164.084 30.186Z"></path>
                                <path fill="url(#f)" d="M256 256.367c53.62 0 164.084 9.188 164.084 30.186 0 84.639-79.107 148.244-164.084 148.244S91.916 371.192 91.916 286.553c0-20.998 110.515-30.186 164.084-30.186m0-2c-25.847 0-67.539 2.238-102.414 7.24-18.773 2.69-33.647 5.88-44.21 9.478-13.094 4.46-19.46 9.52-19.46 15.468 0 40.667 18.063 78.798 50.862 107.37 31.278 27.247 73.275 42.875 115.222 42.875s83.944-15.628 115.222-42.875c32.799-28.572 50.862-66.703 50.862-107.37 0-5.948-6.363-11.008-19.453-15.468-10.56-3.598-25.43-6.787-44.198-9.479-34.868-5-76.571-7.239-102.433-7.239Z"></path>
                                <g clip-path="url(#g)">
                                    <path fill="url(#h)" d="M105.228 291.025a131.333 131.333 0 0 1 1.075-16.81A38.02 38.02 0 0 1 141.3 241.2c27.764-2.006 202.481-2.078 229.476-.084a38.023 38.023 0 0 1 34.91 33.008 131.325 131.325 0 0 1 1.086 16.901c0 20.613-98.674 29.634-151.263 29.634-52.638 0-150.281-9.02-150.281-29.634Z"></path>
                                    <path fill="url(#i)" d="M333.54 416.49a106.742 106.742 0 0 1-.874 13.663 30.9 30.9 0 0 1-28.443 26.832c-22.565 1.63-6.353 3.774-47.824 3.774-43.12 0-29.743-2.085-51.683-3.706a30.903 30.903 0 0 1-28.373-26.827 106.736 106.736 0 0 1-.883-13.737c0-15.62 27.711-23.983 71.794-23.983 5.176 0 3.657 4.08 8.746 4.08 5.392 0 4.33-4.071 9.945-4.071 44.035 0 67.595 8.401 67.595 23.974Z"></path>
                                    <path fill="#7d2b39" d="M256.532 396.585a71.48 71.48 0 0 1 0 29.62 71.474 71.474 0 0 1 0-29.62Z" opacity=".19"></path>
                                </g>
                                <path fill="url(#j)" d="M115.736 126.869s-41.877 5.098-66.652 10.35c0 0-.003 4.236.136 7.335.11 2.422.462 4.682 2.275 6.027 20.284 15.145 50.754 37.816 50.754 37.816-.024.002-4.042 29.86-6.693 55.043-.207 2.277-.818 11.44 2.938 13.672a5.927 5.927 0 0 0 6.426-.298c20.683-14.615 51.657-36.581 51.657-36.581s34.68 15.488 57.787 25.795a6.01 6.01 0 0 0 6.395-.98c2.6-1.918 2.639-11.02 1.98-13.199-7.522-24.19-19.068-53.459-19.068-53.459s25.451-28.189 42.388-46.97a8.523 8.523 0 0 0 2.374-6.101 40.477 40.477 0 0 0-.882-7.216c-25.326-.333-69.132 2.58-69.132 2.58s-18.965-32.9-31.604-54.835a6.039 6.039 0 0 0-5.763-2.959 5.954 5.954 0 0 0-5.038 4.025c-8.121 23.983-20.278 59.955-20.278 59.955Z"></path>
                                <path fill="url(#a)" d="M115.736 118.33s-37.14 7.864-61.915 13.116a6.01 6.01 0 0 0-4.6 4.57 5.91 5.91 0 0 0 2.274 6.027c20.284 15.145 50.754 37.816 50.754 37.816-.024.002-4.027 37.749-6.677 62.932a6.016 6.016 0 0 0 2.922 5.783 5.927 5.927 0 0 0 6.426-.298c20.683-14.616 51.657-36.582 51.657-36.582s34.68 15.488 57.787 25.795a5.951 5.951 0 0 0 8.12-7.208c-7.523-24.191-18.813-60.43-18.813-60.43s25.451-28.188 42.388-46.97a6.024 6.024 0 0 0 1.05-6.39 5.954 5.954 0 0 0-5.391-3.56c-25.326-.333-63.299-.786-63.299-.786s-18.965-32.9-31.604-54.835a6.039 6.039 0 0 0-5.763-2.96 5.954 5.954 0 0 0-5.038 4.026c-8.121 23.982-20.278 59.954-20.278 59.954Z"></path>
                                <path fill="url(#k)" d="M376.87 66.914a5.954 5.954 0 0 0-5.038-4.025 6.039 6.039 0 0 0-5.763 2.96c-12.64 21.934-31.604 54.835-31.604 54.835s-43.806-2.914-69.132-2.582a40.477 40.477 0 0 0-.882 7.217 8.523 8.523 0 0 0 2.374 6.101c16.937 18.781 42.389 46.97 42.389 46.97s-11.546 29.268-19.069 53.46c-.658 2.178-.62 11.28 1.98 13.199a6.01 6.01 0 0 0 6.395.979c23.107-10.307 57.788-25.795 57.788-25.795s30.973 21.966 51.656 36.581a5.927 5.927 0 0 0 6.426.298c3.756-2.233 3.145-11.395 2.938-13.672-2.65-25.182-6.669-55.04-6.693-55.043 0 0 30.47-22.67 50.755-37.816 1.812-1.345 2.165-3.605 2.274-6.027.14-3.099.136-7.335.136-7.335-24.775-5.252-66.652-10.35-66.652-10.35s-12.157-35.972-20.277-59.955Z"></path>
                                <path fill="url(#l)" d="M376.87 58.376a5.954 5.954 0 0 0-5.038-4.025 6.039 6.039 0 0 0-5.763 2.959c-12.64 21.934-31.604 54.836-31.604 54.836s-37.972.452-63.299.785a5.954 5.954 0 0 0-5.39 3.56 6.024 6.024 0 0 0 1.049 6.39c16.937 18.782 42.389 46.97 42.389 46.97s-11.291 36.239-18.813 60.43a5.951 5.951 0 0 0 8.12 7.208c23.106-10.307 57.787-25.795 57.787-25.795s30.973 21.966 51.656 36.582a5.927 5.927 0 0 0 6.426.298 6.016 6.016 0 0 0 2.923-5.783c-2.651-25.183-6.654-62.93-6.678-62.932 0 0 30.47-22.671 50.754-37.816a5.91 5.91 0 0 0 2.275-6.027 6.01 6.01 0 0 0-4.6-4.57c-24.776-5.252-61.916-13.116-61.916-13.116s-12.157-35.972-20.277-59.954Z"></path>
                            </svg>
                    </div>
                `,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
                reverseButtons: true,
                customClass: {
                    title: 'fs-6',
                    cancelButton: 'btn btn-sm btn-secondary',
                    confirmButton: 'btn btn-sm btn-danger',
                    htmlContainer: 'text-left'
                },
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const newStatus = currentStatus === 0 ? 1 : 0;
                    axios.put(`${baseURL}/subscriber/status/${id}`, { status: newStatus })
                        .then(response => {
                            toast.success("Status Updated Successfully!");
                            fetchData();
                        })
                        .catch(error => {
                            console.log(error);
                            toast.error("Status Updation Failed");
                            fetchData();
                        });
                } else {
                    fetchData();
                }
            });
        }


    };

    const handleGoClick = () => {

        const filter = {
            lead: filter_subs_id || '',
            lead_email_id: filteremail_id || '',
            lead_mobile_no: filtermob_no || '',
            area: area || '',
            delivery_point: dp || '',
            date_filter: date_fil_selt_value || '',
            branch_id: branch_id
        };
        if (date_fil_selt_value === 'custom') {
            filter.start_date = custom_stdt_fil_value || '';
            filter.end_date = custom_eddt_fil_value || '';
        }
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchData(filter);
        onClose();
        // window.location.reload();
    };

    // check the start date is in future
    function isDateInFuture(dateStr) {
        // dateStr format: "DD-MM-YYYY"
        const [day, month, year] = dateStr.split('-').map(Number);

        // Create a Date object for the given date (months are 0-based)
        const givenDate = new Date(year, month - 1, day);

        // Create a Date object for today, set time to 00:00:00 to only compare dates
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        return givenDate > today;
    }

    // check the current date is in hold
    function isTodayInDateList(dateString) {
        // Split the string by comma, trim spaces just in case
        const dates = dateString.split(',').map(d => d.trim());

        // Get today's date string in "DD-MM-YYYY" format
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // month is 0-based
        const year = today.getFullYear();
        const todayStr = `${day}-${month}-${year}`;

        // Check if today's date string is in the array
        return dates.includes(todayStr);
    }

    const formatDate = (date) => {
        if (date) {
            const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const d = new Date(date);
            const day = String(d.getDate()).padStart(2, '0');
            const month = months[d.getMonth()];
            const year = d.getFullYear();
            return `${day}-${month}-${year}`;
        } else {
            return '';
        }
    };

    const rowStyle = (data) => {
        if (data.status === 4) {
            return { backgroundColor: '#facacaff', borderBottom: '1px solid #ddd' };
        } else if ((data.hold_dates && isTodayInDateList(data.hold_dates)) || (data.hold_count > 0 && isTodayInDateList(data.hold_dates))) {
            return { backgroundColor: '#dde2ff', borderBottom: '1px solid #ddd' };
        } else if (data.status === 5) {
            return { backgroundColor: '#e0ffd9', borderBottom: '1px solid #ddd' };
        } else {
            return {};
        }
    };

    const [isMaintenance, setIsMaintenance] = useState(false);
    // const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const checkMaintenanceStatus = async () => {
            try {
                const response = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
                const data = response.data.data || [];
                const branchStatus = data.find((item) => item.slug === "subscriberManagement"); // use managebranch slug

                if (isMounted) {
                    setIsMaintenance(branchStatus?.maintenancemode_status === 1);
                }
            } catch (error) {
                console.error("Error checking maintenance mode:", error);
                if (isMounted) setIsMaintenance(false);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        checkMaintenanceStatus();

        return () => {
            isMounted = false;
        };
    }, [baseURL, branch_id]);

    if (loading) {
        return <div>Loading...</div>; // optional loading state
    }

    if (isMaintenance) {
        return (
            <div
                className="d-flex flex-column align-items-center justify-content-center text-center"
                style={{ height: "100vh", width: "100vw" }}
            >
                <h1 className="text-warning mb-3">🚧 Under Maintenance</h1>
                <p className="text-muted fs-5">
                    The <strong>Manage Subscribers</strong> module is currently under maintenance. <br />
                    Please check back later.
                </p>
            </div>
        );
    }

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Manage Subscribers</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Subscriber Management</li>
                    </ol>
                </div>

                {permissions.subscriber_list === 1 && (
                    <div className='d-flex align-items-center gap-3'>

                        <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={() => setFilterOpen(true)}>
                            <span className='me-2'><i className="fa-solid fa-filter fs-8"></i></span>
                            <span className=''>Filter</span>
                        </Link>
                        {permissions.subscriber_filter === 1 && (
                            <Dropdown>
                                <Dropdown.Toggle
                                    as="button"
                                    variant="primary"
                                    className="btn btn-primary text-white btn-sm"
                                    id="tp-btn"
                                >
                                    <span className='me-2'><i className="fa-solid fa-circle-down fs-8"></i></span>
                                    <span className=''>Export</span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={exportCSV} className='px-2'>
                                        <img
                                            src={csv_ico}
                                            alt="CSV"
                                            className='w-30px h-30px'
                                        />
                                        <span className='fs-7 ms-2 font-w500 text-black'>CSV</span>
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={exportExcel} className='px-2'>
                                        <img
                                            src={excel_ico}
                                            alt="Excel"
                                            className='w-30px h-30px'
                                        />
                                        <span className='fs-7 ms-2 font-w500 text-black'>Excel</span>
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={print} className='px-2'>
                                        <img
                                            src={print_ico}
                                            alt="Print"
                                            className='w-30px h-30px'
                                        />
                                        <span className='fs-7 ms-2 font-w500 text-black'>Print</span>
                                    </Dropdown.Item>
                                    {/* <Link to={'//PrintTripSheet'} className="btn btn-primary float-end btn-sm">
                                        <span className='me-2'><i className="fa-solid fa-angle-left fs-8"></i></span>
                                        <span className=''>Add Vehicle</span>
                                    </Link> */}
                                </Dropdown.Menu>
                            </Dropdown>
                        )}
                    </div>
                )}
                {open && modalType === "Edit" && (
                    <Edit show={open} onClose={() => setOpen(false)} selectedId={selectedId} refresh={fetchData} />
                )}
                {open && modalType === "Drop" && (
                    <Drop show={open} onClose={() => setOpen(false)} selectedId={selectedId} refresh={fetchData} />
                )}
                {open && modalType === "Followup" && (
                    <Followup show={open} onClose={() => setOpen(false)} selectedId={selectedId} data={selected_data} refresh={fetchData} />
                )}
            </div>

            <LoadingComponent loading={loading} />

            {permissions.subscriber_list === 1 && (
                <div className='row mb-3'>
                    <div className='d-flex align-items-end justify-content-end'>
                        <div className='col-lg-8 d-flex align-items-center justify-content-end'>

                            <div className="d-flex align-items-center px-1 py-1">
                                <label className=" rounded border border-dark w-25px h-25px me-1" style={{ backgroundColor: '#dde2ff' }}> </label>
                                <label className="fs-7 fw-semibold text-black">Hold</label>
                            </div>

                            <div className="d-flex align-items-center px-1 py-1">
                                <label className=" rounded border border-dark w-25px h-25px me-1" style={{ backgroundColor: '#facacaff' }}> </label>
                                <label className="fs-7 fw-semibold text-black">Drop</label>
                            </div>

                            <div className="d-flex align-items-center px-1 py-1">
                                <label className=" rounded border border-dark w-25px h-25px me-1" style={{ backgroundColor: '#e0ffd9' }}> </label>
                                <label className="fs-7 fw-semibold text-black">Delivered</label>
                            </div>

                        </div>
                    </div>
                </div>
            )}

            {permissions.subscriber_list === 1 && (
                <div className="table-container">

                    {datas.length === 0 && hasFetched && (
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            {/* Left: Show entries dropdown */}
                            <div>
                                <label className="me-2">Show</label>
                                <select
                                    className="form-select d-inline w-auto"
                                    style={{ fontSize: '0.85rem', height: '30px' }}
                                >
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>

                            {/* Right: Search input */}
                            <div>
                                <input
                                    type="text"
                                    style={{ fontSize: '0.85rem', height: '40px' }}
                                    placeholder="Search..."
                                    className="form-control"
                                />
                            </div>
                        </div>
                    )}

                    <table className="table align-top table-row-dashed table-striped fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd' }}>
                        <thead>
                            <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                <th className='min-w-100px'>Subscribers</th>
                                <th className='min-w-100px'>Mobile / Email ID</th>
                                <th className='min-w-100px'>Address</th>
                                <th className='min-w-50px text-center'>User</th>
                                <th className='min-w-50px text-center'>Subscriptions</th>
                                <th className='min-w-50px'>Status</th>
                                <th className='min-w-50px text-end'>Actions</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-600 fw-semibold fs-7">
                            {datas.length === 0 && hasFetched ? (
                                <tr>
                                    <td colSpan="7" className="text-center text-muted py-2">
                                        No data available
                                    </td>
                                </tr>
                            ) : (
                                <>
                                    {datas.map((data, index) => (
                                        <React.Fragment key={data.lead_id}>
                                            <tr style={isVisible[data.lead_id] ? { backgroundColor: '#fff0f0' } : {}} key={data.lead_id}>
                                                <td>
                                                    <div className='d-flex align-items-center'>
                                                        <Button variant="primary tp-btn-light border px-2 pt-1 pb-0 me-1" onClick={() => toggleDiv(data.lead_id)}>
                                                            {isVisible[data.lead_id] ? (
                                                                <span><i className="fa-solid fa-angle-down fs-4"></i></span>
                                                            ) : (
                                                                <span><i className="fa-solid fa-angle-right fs-4"></i></span>
                                                            )}
                                                        </Button>
                                                        <div className='text-black font-w400 fs-7 ms-2'>{data.lead_name}</div>
                                                    </div>
                                                    {checkdate(data.created_at) && (
                                                        <div className='d-block'>
                                                            <img src={new_subs} alt="New Customer" className='cursor-pointer w-65px h-20px' />
                                                        </div>
                                                    )}
                                                    {data.expired_count > 0 && (
                                                        <div className='mt-2'>
                                                            <Badge bg="danger" className='text-white fs-8 py-0 px-1'>{data.expired_count} Delivered</Badge>
                                                        </div>
                                                    )}
                                                </td>
                                                <td>
                                                    <label className='text-black font-w400 fs-7'>{data.lead_mobile}</label>
                                                    <div className='d-block'>
                                                        <label className='text-primary font-w500 fs-7 '>{data.lead_email ? data.lead_email : '-'}</label>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='text-black font-w400 fs-7 w-200px text-wrap'>{data.lead_address ? data.lead_address : '-'}</div>
                                                </td>
                                                <td className='text-center'>
                                                    <Badge bg="info" className='py-0 px-1 fs-8'>{data.user_count}</Badge>
                                                </td>
                                                <td className='text-center'>
                                                    <Badge bg="info" className='py-0 px-1 fs-8'>{data.product_count}</Badge>
                                                </td>
                                                <td>
                                                    <div className="form-check form-switch d-flex align-items-center mb-3">
                                                        <input className="form-check-input" type="checkbox" role="switch" checked={data.status === 0} onChange={() => handleStatusToggle(data.subscriber_id, data.status, data.lead_name)} />
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className="text-end">
                                                        <Dropdown drop=''>
                                                            <Dropdown.Toggle
                                                                as="a"
                                                                className="i-false cursor-pointer"
                                                            >
                                                                <Button variant="primary tp-btn-light px-3 py-2">
                                                                    <span><i className="fa-solid fa-ellipsis-vertical fs-6 mt-1"></i></span>
                                                                </Button>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                {permissions.subscriber_new_subscription === 1 && (
                                                                    <Dropdown.Item as={Link} to={`/new-subscriptions?data=${data.lead_id}`} className='px-2 py-1'>
                                                                        <div className='d-flex align-items-center'>
                                                                            <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                                <span><i className="fa-solid fa-handshake fs-5 text-danger"></i></span>
                                                                            </div>
                                                                            <div className="ms-1 fs-7">New Subscription</div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                )}
                                                                {permissions.subscriber_view === 1 && (
                                                                    <Dropdown.Item as={Link} to="/view-subscribers" state={{ ID: data.subscriber_id }} className='px-2 py-1'>
                                                                        <div className='d-flex align-items-center'>
                                                                            <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                                <span><i className="fa-solid fa-eye fs-5 text-danger"></i></span>
                                                                            </div>
                                                                            <div className="ms-1 fs-7">View Subscriber</div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                )}
                                                                {permissions.subscriber_edit === 1 && (
                                                                    <Dropdown.Item href={"#"} className='px-2 py-1' onClick={() => handleModalToggle_Edit(data.subscriber_id)}>
                                                                        <div className='d-flex align-items-center'>
                                                                            <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                                <span><i className="fa-solid fa-pen-to-square fs-5 text-danger"></i></span>
                                                                            </div>
                                                                            <div className="ms-2 fs-7">Edit Subscriber</div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                )}
                                                                {/* {data?.products?.filter(product => product.status == 3).length > 0 && (
                                                                    <Dropdown.Item href={"#"} className='px-2 py-1' onClick={() => handleModalToggle_Drop(data.subscriber_id)}>
                                                                        <div className='d-flex align-items-center'>
                                                                            <div className="rounded px-1 py-1 text-center bg-transparent me-0">
                                                                                <span><i className="fa-solid fa-ban fs-5 text-danger"></i></span>
                                                                            </div>
                                                                            <div className="ms-2 fs-7">Drop Product</div>
                                                                        </div>
                                                                    </Dropdown.Item>
                                                                )} */}
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </span>
                                                </td>
                                            </tr>
                                            {isVisible[data.lead_id] && (
                                                <>
                                                    <tr style={{ backgroundColor: '#ffffff' }} key={data.sno}>
                                                        <td colSpan={7}>

                                                            <table className="table align-top table-striped table-hover fs-7 gy-1 gs-2">
                                                                <thead>
                                                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                                        <th className='min-w-100px'>Subscription Date</th>
                                                                        <th className='min-w-50px'>User</th>
                                                                        <th className='min-w-80px'>Product </th>
                                                                        <th className='min-w-80px'>Delivery Point </th>
                                                                        <th className='min-w-80px'>Duration </th>
                                                                        <th className='min-w-80px'>Amount/Status </th>
                                                                        <th className='min-w-80px'>Delivery Count </th>
                                                                        <th className='min-w-50px text-center'>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="text-gray-600 fw-semibold fs-7">
                                                                    {data.products.map((prod, index) => (
                                                                        <tr key={index} style={rowStyle(prod)}>
                                                                            <td>
                                                                                <div className='d-flex flex-row align-items-center justify-content-start gap-1'>
                                                                                    <label className='text-black font-w400 fs-7'>{formatDate(prod.created_at)}</label>
                                                                                </div>
                                                                                <div className='d-block '>
                                                                                    {prod.status === 4 && (
                                                                                        <Badge bg="danger" className='text-white fs-7 py-1 px-1'>Drop</Badge>
                                                                                    )}

                                                                                    {prod.status === 6 && (
                                                                                        <Badge bg="info" className='text-white fs-7 py-1 px-1'>In-Active</Badge>
                                                                                    )}

                                                                                    {prod.status === 5 && (
                                                                                        <Badge bg="success" className='text-white fs-7 py-1 px-1'>Delivered</Badge>
                                                                                    )}

                                                                                    {isDateInFuture(prod.format_start_date) && prod.status !== 4 && prod.status !== 5 && prod.status !== 6 ? (
                                                                                        <Badge bg="secondary" className='text-white fs-7 py-1 px-1'>Not Started</Badge>
                                                                                    ) : (
                                                                                        <>
                                                                                            {(prod.hold_dates && isTodayInDateList(prod.hold_dates)) || (prod.hold_count > 0 && isTodayInDateList(prod.hold_dates)) ? (
                                                                                                <>
                                                                                                    {prod.status !== 4 && prod.status !== 5 && (
                                                                                                        <label className='text-white fs-7 font-w600 py-1 px-1 bg-gray-900 rounded'>Hold</label>
                                                                                                    )}
                                                                                                </>
                                                                                            ) : (
                                                                                                <>
                                                                                                    {prod.status !== 4 && prod.status !== 5 && prod.status === 3 && prod.status !== 6 && (
                                                                                                        <Badge bg="warning" className='text-white fs-7 py-1 px-1'>Active</Badge>
                                                                                                    )}
                                                                                                </>
                                                                                            )}
                                                                                        </>
                                                                                    )}

                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className='text-black font-w400 fs-7'>{prod.delivery_person}</div>
                                                                                <div className='d-block'>
                                                                                    <div className=' font-w500 fs-7 text-primary'>{prod.delivery_contact}</div>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className='d-flex flex-column  justify-content-start'>
                                                                                    <label className='text-black font-w400 fs-7'>{prod.product_name}</label>
                                                                                    <label className='text-primary font-w500 fs-7'>{prod.duration_name} ( {prod.duration_days} Days )</label>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className='text-black font-w400 fs-7'>{prod.delivery_point}</div>
                                                                            </td>
                                                                            <td>
                                                                                <label className='text-success fw-bold fs-7'>{formatDate(prod.start_date)}</label>
                                                                                <div className='d-block'>
                                                                                    <label className='text-danger fw-bold fs-7'>{formatDate(prod.end_date)}</label>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className='d-flex flex-column align-items-center justify-content-start gap-1'>
                                                                                    <label className='text-danger font-w600 fs-7'>₹{prod.product_amount}</label>
                                                                                    {prod.payment_status === 0 ? (
                                                                                        <span className='text-white fs-7 font-w600 py-1 px-2 bg-primary rounded'>Paid</span>
                                                                                    ) : (
                                                                                        <span className='text-white fs-7 font-w600 py-1 px-2 bg-danger rounded'>Pending</span>
                                                                                    )}
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className='d-flex align-items-center gap-2 flex-wrap justify-content-center'>
                                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Balance Delivery</span></Tooltip>} >
                                                                                        <Badge bg="danger" className='text-white fs-8 py-0 px-1 cursor-pointer'>{prod.balance}</Badge>
                                                                                    </OverlayTrigger>
                                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delivered</span></Tooltip>} >
                                                                                        <Badge bg="success" className='text-white fs-8 py-0 px-1 cursor-pointer'>{prod.delivered}</Badge>
                                                                                    </OverlayTrigger>
                                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Total Delivery</span></Tooltip>} >
                                                                                        <Badge bg="info" className='text-white fs-8 py-0 px-1 cursor-pointer'>{prod.total_delivery}</Badge>
                                                                                    </OverlayTrigger>
                                                                                </div>

                                                                                {prod.hold_count > 0 && (
                                                                                    <div className='text-center mt-1'>
                                                                                        <Dropdown drop='start'>
                                                                                            <Dropdown.Toggle
                                                                                                as="a"
                                                                                                className="i-false cursor-pointer"
                                                                                            >
                                                                                                <Button variant="bg-none py-0 px-0">
                                                                                                    <span className='fs-8 bg-warning px-1 border border-dark rounded font-w500 text-black'>{prod.hold_count} Days Hold</span>
                                                                                                </Button>
                                                                                            </Dropdown.Toggle>
                                                                                            <Dropdown.Menu className='mw-100 flex-wrap text-wrap px-2 bg-warning'>
                                                                                                <div className='d-block fs-7 font-w500 text-black text-center bg-white rounded mb-2'>Hold</div>
                                                                                                {prod.hold_dates && prod.hold_dates.split(',').map((date, index) => (
                                                                                                    <div key={index} className='d-block fs-7 font-w500 text-black'>
                                                                                                        {date}
                                                                                                    </div>
                                                                                                ))}
                                                                                            </Dropdown.Menu>
                                                                                        </Dropdown>
                                                                                    </div>
                                                                                )}

                                                                            </td>
                                                                            <td>
                                                                                <div className='text-center'>
                                                                                    {/* {prod.is_relative === 1 && permissions.subscriber_convert === 1 ? ( */}
                                                                                    {prod.is_relative === 1 ? (
                                                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom"
                                                                                            overlay={<Tooltip className="toltip-popover"> <span className="fs-8 text-white fw-semibold">Convert Subscriber</span> </Tooltip>}>
                                                                                            <Button variant="primary tp-btn-light px-2 py-1 me-1" href={`/apf/manage-subscribers-convert?data=${prod.product_id}`}>
                                                                                                <span><i className="fa-solid fa-people-carry-box fs-4 mt-1"></i></span>
                                                                                            </Button>
                                                                                        </OverlayTrigger>
                                                                                    ) : (
                                                                                        <div className="text-center">
                                                                                            No Actions
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </>
                            )}
                        </tbody>
                    </table>

                    {datas.length === 0 && hasFetched && (
                        <div className="d-flex justify-content-between align-items-center mt-3">
                            {/* Bottom left: Showing x to y of z entries */}
                            <div>
                                <span className="text-muted">
                                    Showing 0 to 0 of 0 entries
                                </span>
                            </div>

                            {/* Bottom right: Pagination */}
                            <nav>
                                <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                    <li className={`page-item disabled`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} >Previous</button>
                                    </li>

                                    <li key={1} className={`page-item active`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} >1</button>
                                    </li>

                                    <li className={`page-item disabled`}>
                                        <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} >Next</button>
                                    </li>
                                </ul>
                            </nav>

                        </div>
                    )}
                </div>
            )}

            {permissions.subscriber_list === 0 && (
                <div className='align-content-center' style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '10%',
                    // height: '100vh',       // full viewport height
                    color: 'red',          // text-danger equivalent
                    fontSize: '24px',      // increase font size
                    fontWeight: 'bold'     // optional for emphasis
                }}>
                    <label>No Access</label>
                </div>
            )}

            <Drawer
                anchor="right"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                disableEscapeKeyDown
                BackdropProps={{
                    onClick: (e) => e.stopPropagation(),
                }}
                sx={{
                    width: 400,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: 400,
                        boxSizing: 'border-box',
                    },
                    '@media (max-width: 375px)': {
                        '& .MuiDrawer-paper': {
                            width: 320,
                        },
                    },
                    '@media (max-width: 320px)': {
                        '& .MuiDrawer-paper': {
                            width: 280,
                        },
                    },
                }}
            >
                <div className='modal-header mb-0 px-4 pt-2 pb-0'>
                    <h5 className='fs-4' style={{ color: '#ea1d25' }}>Subscribers Filter</h5>
                    <div>
                        <Button variant="" type="button" size='sm' data-dismiss="modal" onClick={onClose}>
                            <span className='fs-2'>×</span>
                        </Button>
                    </div>
                </div>
                <div className='card border-0'>
                    <div className='card-body py-0'>
                        <div className='row mb-2 py-2'>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Subscribers</label>
                                <Select
                                    value={subsribersOpt.find(option => option.value === filter_subs_id) || null}
                                    onChange={(selectedOption) => setFilterSubsID(selectedOption.value)}
                                    options={subsribersOpt}
                                    placeholder="Select Subscribers"
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Email ID</label>
                                <input type="text" className="form-control" placeholder="Enter Email ID"
                                    value={filteremail_id}
                                    onChange={(e) => setFilterEmail(e.target.value)} />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Mobile No</label>
                                <input type="text" className="form-control" placeholder="Enter Mobile No"
                                    value={filtermob_no}
                                    onChange={(e) => {
                                        const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                        setFilterMob(onlyNums);
                                    }}
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Area</label>
                                <Select
                                    value={areaOption.find(option => option.value === area) || null}
                                    options={areaOption}
                                    onChange={(selectedOption) => setArea(selectedOption.value)}
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Delivery Point</label>
                                <Select
                                    value={dppoption.find(option => option.value === dp) || null}
                                    onChange={(selectedOption) => setDp(selectedOption.value)}
                                    options={dppoption}
                                />
                            </div>
                            <div className="col-lg-12 mb-2">
                                <label className="text-black font-w500 fs-7">Date</label>
                                <Select
                                    value={date_fil_options.find(option => option.value === date_fil_selt_value)}
                                    onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                    options={date_fil_options}
                                    menuPlacement="top"
                                />
                            </div>
                            {date_fil_selt_value === "all" && <></>}
                            {date_fil_selt_value === "today" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">Today</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            // value={"05/18/2020 02:20:36 PM"}
                                            value={today_fil_value}
                                            onChange={setTodayFilValue}
                                            format="DD-MM-YYYY"
                                            // format="DD/MM/YYYY hh:mm:ss A"
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "this_week" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_stdt_fil_value}
                                                onChange={setWeekSTDTFilValue}
                                                format="DD-MM-YYYY"
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={week_eddt_fil_value}
                                                onChange={setWeekEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                                readOnly={true}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            {date_fil_selt_value === "this_month" && (
                                <div className="col-lg-12 mb-2">
                                    <label className="text-black font-w500 fs-7">This Month</label>
                                    <div className='datepicker-wrapper d-flex'>
                                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                        <DatePicker
                                            value={month_fil_value}
                                            onChange={setMonthFilValue}
                                            format="MMM-YYYY"
                                            calendarPosition="top"
                                            mode="single"
                                            onlyMonthPicker={true}
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            )}
                            {date_fil_selt_value === "custom" && (
                                <>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">Start Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_stdt_fil_value}
                                                onChange={setCustomSTDTFilValue}
                                                format="DD-MM-YYYY"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 mb-2">
                                        <label className="text-black font-w500 fs-7">End Date</label>
                                        <div className='datepicker-wrapper d-flex'>
                                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                            <DatePicker
                                                value={custom_eddt_fil_value}
                                                onChange={setCustomEDDTFilValue}
                                                format="DD-MM-YYYY"
                                                calendarPosition="top-end"
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-1">
                        <Button className="me-2 btn-sm" variant="secondary" onClick={() => {
                            setFilterSubsID(null);
                            setFilterMob('');
                            setFilterEmail('');
                            setArea(null);
                            setDp(null);
                            setDateFilSeltValue('all');
                            onClose();
                            setHasFetched(false);
                            if ($.fn.dataTable.isDataTable(tableRef.current)) {
                                $(tableRef.current).DataTable().destroy();
                            }
                            fetchData();
                            // window.location.reload();
                        }}>
                            <span className='font-w400'>Reset</span>
                        </Button>
                        <Button className="me-2 btn-sm" variant="primary" onClick={handleGoClick}>
                            <span className='font-w400'>Go</span>
                        </Button>
                    </div>
                </div>
            </Drawer>

        </>
    )
}
export default Subscribers;


